// ─────────────────────────────────────────────────────────────────────────────
// Mack · the stage classification rule — ONE definition, shared.
//
// Extracted in build-06. It previously lived in PhasesTab and was MIRRORED into
// FlowTab, because build-05 was not permitted to modify a cleared file. Two
// copies of a derivation rule is exactly the thing that drifts, so the copy and
// its sync warning are gone and both tabs import from here.
//
// CLASSIFICATION IS DERIVED, NEVER ASSIGNED:
//   stage = f( sign(Δgrowth), sign(Δinflation) )
//
//   rising  / rising   → Reflation
//   falling / rising   → Stagflation
//   rising  / stable   → Expansion
//   falling / falling  → Deflation
//
// Anything else — notably the Reserve bloc sheet, which is official-sector and
// carries no growth/inflation read — returns the em-dash placeholder.
// ─────────────────────────────────────────────────────────────────────────────

export type MackDelta = 'rising' | 'falling' | 'stable';

export const NO_STAGE = '—';

export function classifyStage(dg: string, di: string): string {
  if (dg === 'rising'  && di === 'rising')   return 'Reflation';
  if (dg === 'falling' && di === 'rising')   return 'Stagflation';
  if (dg === 'rising'  && di === 'stable')   return 'Expansion';
  if (dg === 'falling' && di === 'falling')  return 'Deflation';
  return NO_STAGE;
}

// The modal stage across a set of sheets — "which stage is the book in right
// now". Used by Flow's rotation panel to highlight the dominant row. Sheets with
// no stage read do not vote.
export function dominantStageOf(
  sheets: { delta_growth: string; delta_inflation: string }[],
): string {
  const tally = new Map<string, number>();
  sheets.forEach(s => {
    const st = classifyStage(s.delta_growth, s.delta_inflation);
    if (st !== NO_STAGE) tally.set(st, (tally.get(st) ?? 0) + 1);
  });
  let best = '', n = 0;
  tally.forEach((count, st) => { if (count > n) { n = count; best = st; } });
  return best;
}
